(function () {

    'use strict';

    angular.module('app').controller('AccountingController', AccountingController);

    AccountingController.$inject = ['AccountingInvoicesTableService'];

    function AccountingController(AccountingInvoicesTableService) {
        const vm = this;
        vm.accountingInvoicesTable = new AccountingInvoicesTableService();
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/AccountingController.js